import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { AccessService } from 'src/app/providers/access/access.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';

@Component({
  selector: 'app-preferences-types',
  templateUrl: './preferences-types.page.html',
  styleUrls: ['./preferences-types.page.scss'],
})
export class PreferencesTypesPage implements OnInit {
  unreadCount: any;
  user: any;
  lockTimer:any;
  userTimer:any;
  preferencesForm: FormGroup;

  constructor(
    private storageService: StorageService,
    private apiService: ApiService,
    public accessService: AccessService,
    public formBuilder: FormBuilder,
    public alertController: AlertController,
    ) {
      this.preferencesForm = this.formBuilder.group({
        appTimeout: [''],
      });

      setInterval(() => {
        this.storageService.getObject('lockTimer').then((timerResult) => {
        var mins = Math.floor(timerResult/60000);
        var secs = (Number.parseFloat(timerResult) % 60000)/1000;
        if (mins>0)
        {
          this.lockTimer = mins+' minutes and '+String(secs).padStart(2, '0') + ' seconds';
        }
        else
        {
          this.lockTimer = String(secs).padStart(2, '0') + ' seconds';
        }
        //console.log(this.lockTimer);
        });
      }, 1000);
     }
  ionViewDidEnter() {
    this.storageService.getObject('userLockTimeout').then((timerResult) => {
      //console.log('setting lock timeout to: ', timerResult);
      this.userTimer = timerResult;
      this.preferencesForm.controls.appTimeout.setValue(timerResult);
    });
    this.accessService.resetLogoutTimer();
    this.accessService.startTimer();

  }
  ngOnInit() {
    this.storageService
      .getObject('userInfo')
      .then((result) => {
        if (result != null) {
          this.user = result;
          this.getnotificationCount();
        }
      })
      .catch((e) => {
        // Handle errors here
      });
  }
  updateTimeout(event)
  {
    var timeOut = this.preferencesForm.controls.appTimeout.value;
    if (timeOut != this.userTimer)  // only do this if different to current setting!
    {
      this.userTimer = timeOut;
      //console.log('timeout Selected: ',timeOut);
      const params = {
        User: {
          username: this.user.username,
          password: this.user.password,
        },
        app_timeout: timeOut,
      };
      this.apiService
        .login('updateUserSettings', params)
        .subscribe(
          (res) => {
            //console.log('update res: ',res);
            if (res.error === false) {
              this.preferencesForm.controls.appTimeout.setValue(timeOut);
              this.presentSuccessfulAlert('Timeout Updated','Your app inactivity timeout setting was successfully updated'); 
              this.accessService.resetLogoutTimer();
              this.accessService.startTimer();
              //show success alert
            }
            else
            {
              //console.log(res.message);
              //failure alert?
            }
          },
          (err) => { }
        );
      this.accessService.resetLogoutTimer();
      }
  }
  async presentSuccessfulAlert(alertheader, alertmsg) {
    if (!alertheader)
    {
      alertheader = 'Update Successful';
    }
    const alert = await this.alertController.create({
      cssClass: 'success_alert', 
      header: alertheader,
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }
  getnotificationCount() {
    const params = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    };
    this.apiService
      .post('user/get-unread-notification-count', params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => { }
      );
  }

}
